import { environment } from 'src/environments/environment'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Directive } from '@angular/core';
import { Injectable, } from '@angular/core';

@Directive({
  selector: 'app-geolocationservice'
})
@Injectable({ providedIn: 'root' })
export class GeolocationService {

constructor(private httpclient:HttpClient) { }

getGeoLocation(currentLocation:any,portfolio:string){
  let params = new HttpParams();
  params = params.set("portfolio", portfolio);
  return this.httpclient
      .post(environment.baseUrl + '/tvsm/getmerchantportfolio',currentLocation,{params:params}); 

}
getLoanSummary(custid:string){
  let params = new HttpParams();
  params = params.set("custid", custid);
  return this.httpclient
     .post(environment.baseUrl + '/emicard/getLoanSummary',null,{params:params}); 
}
getLoanSummaryDetails(agreementNo:string){
  let params = new HttpParams();
  params = params.set("agreementNo", agreementNo);
  return this.httpclient
     .post(environment.baseUrl + '/emicard/getLoanSummaryDetails',null,{params:params}); 
} 

getManageCard(reqData:any){
  return this.httpclient
  .post(environment.baseUrl + '/tvsm/getManageCard',reqData); 

}    

getOnlineShopUrl(){
  return this.httpclient
  .post(environment.baseUrl + '/tvsm/getOnlineShopUrl',null); 
 
}
getshopOnlineBanner(){
  return this.httpclient
  .post(environment.baseUrl + '/tvsm/getShoponlinebanners',null); 
}
saveData(mfiData: any) {
  return this.httpclient
  .post(environment.baseUrl + '/tvsm/saveMfiData',mfiData); 
}

getUrl(reqData:any){
  return this.httpclient
  .post(environment.baseUrl + '/tvsm/geturlRedirection',reqData); 
}
generateOTP(){
  return this.httpclient
  .post(environment.baseUrl + '/tvsm/generateOtp',null); 
}   
getRedirectionPage(mobileNo:string ,dealercode:string){
  let params =new HttpParams();
  params=params.set("mobileNo",mobileNo);
  params=params.set("dealercode",dealercode)
  return this.httpclient
  .post(environment.baseUrl + '/tvsm/getRedirectionPage',null,{params:params}); 

}  
getTvsmOnboardingCustUrl(){
  return this.httpclient
  .post(environment.baseUrl + '/tvsm/getTvsmOnboardingCustUrl',null); 
 
} 

getMerchantStoreDealers(reqData:any){
  return this.httpclient
  .post(environment.baseUrl + '/tvsm/getDealerDetails',reqData); 
 
}  

getPreApprovalLetter(reqData:any){
  return this.httpclient
  .post(environment.baseUrl + '/tvsm/preAppLetter',reqData); 
 
} 
sendMailToDealer(reqData:any){
  return this.httpclient
  .post(environment.baseUrl + '/tvsm/sendmail',reqData); 
 
} 

generateTvsmOnboardingCustUrl(data:any){
  return this.httpclient
      .post(environment.baseUrl + '/tvsm/generateTvsmOnboardingCustUrl',data); 

}
getDecryptData(reqData: any) {
  let params =new HttpParams();
  params=params.set("data",reqData);
  return this.httpclient
  .post(environment.baseUrl + '/tvsm/getDecryptData',null,{params:params}); 
}

}

